/**
 * Coerce an unknown value to a string for display or URL serialization without
 * ever falling back to the unhelpful default `"[object Object]"` — plain objects
 * (and arrays) are JSON-encoded instead. Null/undefined become an empty string.
 *
 * Used wherever a value typed as `unknown` (form field values, query params)
 * must be stringified; the explicit object branch is what keeps SonarQube's
 * no-base-to-string (S6551) satisfied and, more importantly, avoids silently
 * rendering an object as `[object Object]`.
 */
export function toText(value: unknown): string {
  if (value === null || value === undefined) return '';
  if (typeof value === 'string') return value;
  if (typeof value === 'number' || typeof value === 'boolean' || typeof value === 'bigint') {
    return String(value);
  }
  if (typeof value === 'symbol') return value.toString();
  // Objects, arrays, and functions: JSON-encode rather than emit "[object Object]"
  // (functions serialize to undefined, hence the empty-string fallback).
  return JSON.stringify(value) ?? '';
}
